import type { ActivityHistory, ActivityHistoryKind } from '../utils/activity-history';
import { useAddonPurchase } from './use-addon-purchase';

export function useOpenActivityHistoryAddon(
  kind: ActivityHistoryKind,
  { lookbackStart, addonLookbackStart }: ActivityHistory,
): () => void {
  const { openAddon } = useAddonPurchase();

  return () => {
    void openAddon({ request: { key: 'activity-history', kind, lookbackStart, addonLookbackStart } });
  };
}
